import React from "react";
import { makeStyles, Box, Grid } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import CurrencyFormat from "react-currency-format";

import BusinessAccount from "../../../models/BusinessAccount";
import Account from "../../../models/Account";
import { displayWalletType } from "../../../settings/WalletType";
import { AmountDetail } from "./AmountDetail";

interface BalanceDetailsProps {
  accounts: Array<BusinessAccount | Account>;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  }),
  { name: "balance-details-styles" }
);

export default function BalanceDetails(props: BalanceDetailsProps) {
  const classes = useStyles(props);
  // Props
  const { accounts } = props;

  return (
    <Box className={classes.root}>
      <Grid container>
        {accounts.map((account, index) => {
          return (
            <Grid item xs={12} sm={index % 2 === 0 ? 4 : 8}>
              <AmountDetail
                title={
                  <FormattedMessage
                    id={displayWalletType(account.wallet_type)}
                  />
                }
                subTitle={
                  <CurrencyFormat
                    value={account.balance}
                    suffix={` ${account.currency.code.toUpperCase()}`}
                    displayType="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    renderText={(formattedValue: string) => (
                      <Box component="span">{formattedValue}</Box>
                    )}
                  />
                }
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
